module.exports = __webpack_public_path__ + "static/img/Rectangle.4defe29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/Rectangle.png
// module id = Sczn
// module chunks = 1